export default "__VITE_ASSET__CWXIyGt6__"